import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  StatsRow,
  StatCard,
  StatLabel,
  StatValue,
  ChecklistItem,
  Wrapper
} from './style'
import ProgressSection from '../ProgressSection'
import AlertIconCircle from '@/assets/icons/alert-icon-circle'
import SuccessIcon from '@/assets/icons/success-icon'

const ResponseTab = ({ response, responseStatus, isDraft }) => {
  const completedItems = [
    {
      key: 'conservationActions',
      labelId: 'monitoringResponseCompletedConservationActions',
      labelDefaultMessage: 'Conservation actions',
      isCompleted: !!response?.response_action_id
    },
    {
      key: 'managementPlanning',
      labelId: 'monitoringResponseCompletedManagementPlanning',
      labelDefaultMessage: 'Management planning',
      isCompleted: !!response?.response_planning_id
    },
    {
      key: 'protectionCoverageAnalysis',
      labelId: 'monitoringResponseCompletedProtectionCoverage',
      labelDefaultMessage: 'Protection coverage analysis',
      isCompleted: response?.designation_pa_id != null && response?.designation_oecms_id != null
    }
  ]

  return (
    <Wrapper data-test="monitoring-response-tab">
      <ProgressSection
        percent={responseStatus?.progress}
        status={responseStatus?.status}
        labelId="monitoringResponseEvaluationProgress"
        labelDefaultMessage="Response evaluation progress: {percent}%"
        isDraft={isDraft}
      />

      <StatsRow>
        <StatCard $breakDown>
          {completedItems.map(({ key, labelId, labelDefaultMessage, isCompleted }) => (
            <ChecklistItem key={key}>
              {isCompleted ? <SuccessIcon /> : <AlertIconCircle />}
              <FormattedMessage id={labelId} defaultMessage={labelDefaultMessage} />
            </ChecklistItem>
          ))}
        </StatCard>

        <StatCard>
          <StatLabel>
            <FormattedMessage id="monitoringActionsUnderway" defaultMessage="Conservation actions underway" />
          </StatLabel>
          <StatValue>{response?.actions_underway_count || 0}</StatValue>
        </StatCard>

        <StatCard>
          <StatLabel>
            <FormattedMessage id="monitoringAdditionalActionsNeeded" defaultMessage="Additional actions needed" />
          </StatLabel>
          <StatValue>{response?.actions_needed_count || 0}</StatValue>
        </StatCard>
      </StatsRow>
    </Wrapper>
  )
}

export default ResponseTab
